import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import logo from "assets/img/LOGO-OCSB.gif";

import FarmerMasterService from "../services/farmermaster.service";
// import useFetch from './useFetch';

const BlogDetails = () => {
  const [data, setData] = useState([]);
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  useEffect(() => {
    FarmerMasterService.checkRegsugarcaneMaster(id)
      .then((response) => {
        setData(response.data);
        setIsPending(false);
      })
      .catch((err) => setError(err));
  }, [id]);

  return (
    <Container>
      <div className="blog-details">
        {isPending && <div>Loading...</div>}
        {error && <div>{error}</div>}
        {data === null ? (
          <h2>ไม่มีเลขหัวหน้ากลุ่มชาวไร่อ้อย</h2>
        ) : (
          <article>
            <div style={{ textAlign: "center" }}>
              <img src={logo} width="200" height="200" alt="Logo"></img>
            </div>
            <h2>เลขบัตรประจำตัว หน.กลุ่ม ชาวไร่อ้อย : {data.farmer_card}</h2>
            <hr></hr>
            <h4>ชื่อ : {data.name}</h4>
            <h4
              style={
                data.status_text == "หน. กลุ่ม"
                  ? { color: "green" }
                  : { color: "red" }
              }
            >
              สถานะ : {data.status_text}
            </h4>
          </article>
        )}
      </div>
    </Container>
  );
};

export default BlogDetails;
